import { useQuery } from '@tanstack/react-query';
import { ItemsApi } from '@/lib/api/common/items';
import type { ItemFieldDto } from '@/lib/api/types/items';
import { commonQueryKeys } from '@/lib/query-keys/common';

const EMPTY_SET: ReadonlySet<string> = new Set();

export const useSortableItemFields = (): {
  sortableItemFields: ReadonlySet<string>;
  isLoaded: boolean;
} => {
  const { data, isSuccess } = useQuery({
    queryKey: commonQueryKeys.itemFields.all(),
    queryFn: () => ItemsApi.getItemFields(),
    staleTime: Number.POSITIVE_INFINITY,
    select: (fields: ItemFieldDto[]) =>
      new Set(fields.filter((f) => f.sortable).map((f) => f.name)) as ReadonlySet<string>,
  });
  return {
    sortableItemFields: data ?? EMPTY_SET,
    isLoaded: isSuccess,
  };
};
